import React, { useEffect, useRef, useState, type FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import LoadingView from '../components/LoadingView';
import api from '../services/api';
import type SharedChart from '../models/SharedChartModel';
import ChartResult from '../components/ChartResult';

const ChartResults: FC = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [sharedCharts, setSharedCharts] = useState<SharedChart[]>([]);
    const [hasInstructorNotesPermission, setHasInstructorNotesPermission] =
        useState(false);

    const toast = useRef<Toast>(null);

    const [parameters] = useSearchParams();
    const userId = Number(parameters.get('id'));

    useEffect(() => {
        const pullSharedCharts = async () => {
            const {
                sharedCharts,
                hasInstructorNotesPermission,
                success,
                error,
            } = await api.getSharedCharts(userId);
            setSharedCharts(sharedCharts);
            setHasInstructorNotesPermission(hasInstructorNotesPermission);
            if (!success) {
                setErrorMessage(error ?? 'unknown error');
            }

            setLoading(false);
        };

        void pullSharedCharts();
    }, [userId]);

    return (
        <>
            <Toast ref={toast} position="top-right" />
            <div className="text-primary text-3xl pb-4">
                Charts for {parameters.get('user')}
            </div>
            {loading && <LoadingView />}
            {!loading && errorMessage && (
                <div className="text-primary text-xl">
                    Error: {errorMessage}
                </div>
            )}
            {!loading && !errorMessage && (
                <>
                    {sharedCharts.map((chartData, index) => (
                        <ChartResult
                            key={userId}
                            toast={toast}
                            friendId={userId}
                            chartData={chartData}
                            cycleNumber={sharedCharts.length - index}
                            hasInstructorNotesPermission={
                                hasInstructorNotesPermission
                            }
                        />
                    ))}
                    {sharedCharts.length === 0 && (
                        <div className="text-primary text-center">
                            No charts found
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default ChartResults;
